import React from "react";
/* eslint-disable */
import {
    Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

    render() {
        const reportDetails = this.props.reportDetails;
        const data = this.props.searchData;
        const totalCals = this.props.totalCals;

        return (
            <div align='left'>
                <h3><center><u>Supplier Payment Status Report</u></center></h3>
                <div >&nbsp;</div>
                <Box minWidth={1150}>
                    <TableContainer>
                        <Table aria-label="simple table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">FCC Name</TableCell>
                                    <TableCell align="left">FCC Code</TableCell>
                                    <TableCell align="left">GRN Number</TableCell>
                                    <TableCell align='left'>GRN Date</TableCell>
                                    <TableCell align="left">Supplier Code</TableCell>
                                    <TableCell align="left">Supplier Name</TableCell>
                                    <TableCell align="left">Amount</TableCell>
                                    <TableCell align="left">Approval Status</TableCell>
                                    <TableCell align="left">Payment Status</TableCell>
                                    <TableCell align="left">Payment Posting Date</TableCell>
                                    <TableCell align="left">Is Renitiate</TableCell>
                                    <TableCell align="left">Reinitiate Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reportDetails.map((row) => {
                                    return (
                                        <TableRow key={row.grnNumber}>
                                            <TableCell align="left">{row.factoryName}</TableCell>
                                            <TableCell align="left">{row.factoryCode}</TableCell>
                                            <TableCell align="left">{row.grnNumber}</TableCell>
                                            <TableCell align="left">{moment(new Date(row.goodsRecieveDate)).format('YYYY-MM-DD')}</TableCell>
                                            <TableCell align="left">{row.farmerCode}</TableCell>
                                            <TableCell align="left">{row.accountName}</TableCell>
                                            <TableCell align="right">{parseFloat(row.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                            <TableCell align="left">
                                                {row.approvalStatus == 1 ? "New"
                                                    : row.approvalStatus == 2 ? "FDC First Approved"
                                                        : row.approvalStatus == 3 ? "FDC Second Approved"
                                                            : row.approvalStatus == 4 ? "Finance First Approved"
                                                                : row.approvalStatus == 5 ? "Finance Second Approved"
                                                                    : row.approvalStatus == 6 ? "FDC First Rejected"
                                                                        : row.approvalStatus == 7 ? "FDC Second Rejected"
                                                                            : row.approvalStatus == 8 ? "Finance First Rejected"
                                                                                : row.approvalStatus == 9 ? "Finance Second Rejected"
                                                                                    : "Active"}
                                            </TableCell>
                                            <TableCell align="left">{row.approvalStatus == 5 ? "Approved" :
                                                row.approvalStatus == 6 || row.approvalStatus == 7 || row.approvalStatus == 8 || row.approvalStatus == 9 ? "Rejected" : "Pending"}</TableCell>
                                            <TableCell align="left">{row.paymentPostingDate == '0001-01-01T00:00:00' ? '-' : moment(new Date(row.paymentPostingDate)).format('YYYY-MM-DD')}</TableCell>
                                            <TableCell align="left">{row.isReinitiste == true ? 'True' : 'False'}</TableCell>
                                            <TableCell align="left">{row.formattedReInitiateDate}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                            <TableRow>
                                <TableCell align="left"><b>Total</b></TableCell>
                                <TableCell colSpan={5} />
                                <TableCell align="right"><b>{parseFloat(totalCals).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b></TableCell>
                                <TableCell colSpan={9} />
                            </TableRow>
                        </Table>
                    </TableContainer>
                </Box>
            </div>

        );
    }
}
